import { render, staticRenderFns } from "./textMessageTemplate.vue?vue&type=template&id=47fd1d68&scoped=true&"
import script from "./textMessageTemplate.vue?vue&type=script&lang=js&"
export * from "./textMessageTemplate.vue?vue&type=script&lang=js&"
import style0 from "./textMessageTemplate.vue?vue&type=style&index=0&id=47fd1d68&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fd1d68",
  null
  
)

export default component.exports